import React from "react";
import { observer } from "mobx-react";
import { LlmProviderUpdateStore } from "../../store";
import { LlmProviderUpdateForm } from "./LlmProviderUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type LlmProviderUpdateProps = {
  llmProviderUpdateStore: LlmProviderUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const LlmProviderUpdate: React.FC<LlmProviderUpdateProps> = observer(
  ({ llmProviderUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={llmProviderUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={llmProviderUpdateStore.savedButOutdated}
          onReload={() => llmProviderUpdateStore.reloadLlmProvider()}
          reloadDisabled={llmProviderUpdateStore.isProcessing}
        />
        <LlmProviderUpdateForm
          llmProviderUpdateStore={llmProviderUpdateStore}
          nameError={llmProviderUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            llmProviderUpdateStore.setNameValue(value);
          }}
          name={llmProviderUpdateStore.entityValues.name}
          codeError={llmProviderUpdateStore.errors.code?.message}
          onCodeChange={(value: string) => {
            llmProviderUpdateStore.setCodeValue(value);
          }}
          code={llmProviderUpdateStore.entityValues.code}
          requiresApiKeyError={
            llmProviderUpdateStore.errors.requiresApiKey?.message
          }
          onRequiresApiKeyChange={(value: boolean) => {
            llmProviderUpdateStore.setRequiresApiKeyValue(value);
          }}
          requiresApiKey={llmProviderUpdateStore.entityValues.requiresApiKey}
          requiresBaseUrlError={
            llmProviderUpdateStore.errors.requiresBaseUrl?.message
          }
          onRequiresBaseUrlChange={(value: boolean) => {
            llmProviderUpdateStore.setRequiresBaseUrlValue(value);
          }}
          requiresBaseUrl={llmProviderUpdateStore.entityValues.requiresBaseUrl}
          defaultModelsError={
            llmProviderUpdateStore.errors.defaultModels?.message
          }
          onDefaultModelsChange={(value: string[]) => {
            llmProviderUpdateStore.setDefaultModelsValue(value);
          }}
          defaultModels={llmProviderUpdateStore.entityValues.defaultModels}
          logoUrlError={llmProviderUpdateStore.errors.logoUrl?.message}
          onLogoUrlChange={(value: string) => {
            llmProviderUpdateStore.setLogoUrlValue(value);
          }}
          logoUrl={llmProviderUpdateStore.entityValues.logoUrl}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={llmProviderUpdateStore.saveDisabled}
          onSave={() => llmProviderUpdateStore.saveLlmProvider()}
          onCancel={() => llmProviderUpdateStore.cancelLlmProvider()}
        />
        <ErrorDialog
          open={llmProviderUpdateStore.errorDialogOpened}
          title={llmProviderUpdateStore.errorTitle}
          description={llmProviderUpdateStore.errorDescription}
          onClose={() => llmProviderUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={llmProviderUpdateStore.confirmDialogOpened}
          title={llmProviderUpdateStore.confirmDialogTitle}
          description={llmProviderUpdateStore.confirmDialogDescription}
          onConfirm={() => llmProviderUpdateStore.executeConfirmedAction()}
          onCancel={() => llmProviderUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
